import React from 'react';

// Film-grain overlay via SVG feTurbulence — organic texture, no GPU cost.
const noise = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;

export default function Grain({ opacity = 0.06, fixed = true }) {
    return (
        <div
            aria-hidden="true"
            style={{
                position: fixed ? 'fixed' : 'absolute',
                inset: 0,
                backgroundImage: noise,
                backgroundRepeat: 'repeat',
                backgroundSize: '140px 140px',
                opacity,
                pointerEvents: 'none',
                zIndex: fixed ? 2147483000 : 3,
                mixBlendMode: 'overlay',
            }}
        />
    );
}
